// OwnTaxValuesList.jsx
import React, { useState } from "react";
import AddTaxValueModal from "./AddTaxValueModal";

const OwnTaxValuesList = () => {
  const [showAddModal, setShowAddModal] = useState(false);

  // Dummy data
  const taxValues = [
    { name: "GST", percentage: 18 },
    { name: "Service Tax", percentage: 5 },
    { name: "Luxury Tax", percentage: 12 },
  ];

  return (
    <div className="relative min-h-screen bg-white rounded-xl shadow-md p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Own Tax Values</h2>

      <div className="grid grid-cols-1 gap-4">
        {taxValues.map((tax, index) => (
          <div key={index} className="bg-gray-50 p-4 rounded-lg shadow flex justify-between items-center">
            <span className="text-gray-700 font-medium">{tax.name}</span>
            <span className="text-primary font-semibold">{tax.percentage}%</span>
          </div>
        ))}
      </div>

      {/* Add New Button Fixed to Bottom */}
      <div className="absolute bottom-4 left-0 w-full px-4">
        <button
          onClick={() => setShowAddModal(true)}
          className="w-full bg-primary text-white py-2 rounded-md shadow-lg "
        >
          + Add New Tax Value
        </button>
      </div>

      {showAddModal && <AddTaxValueModal onClose={() => setShowAddModal(false)} />}
    </div>
  );
};

export default OwnTaxValuesList;